import { call, delay, put, takeLatest } from "redux-saga/effects";
import { startLoader, stopLoader } from "../../../utils/commonFunctions";

// for toast
import { toast } from "react-toastify";

import {  CustomerUserActions, CustomerUserActionTypes } from "../../actionTypes/customerUserActionTypes";

import { 
    changeCustomerUserPasswordApi,
    createCustomerUserApi,
    editCustomerUserDataByIdApi,
    getCustomerUserDataByIdApi,
    getCustomerUserListApi 
} from "../requests/master/customerUserRequests";

import { setPostApiStatus, setPutApiStatus  } from "../../actions/apiStatusActions";
import { getCustomerUserList,
     setCustomerUserDataById,
     setCustomerUserList,
     setCustomerUserListPageCount 
    } from "../../actions/customerUserActions";


function* createCustomerUserHandler(action: CustomerUserActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(createCustomerUserApi, action.payload);

    if (data.status) {
      // toast message
      toast.success(data?.message, {
        position: "top-right",
      });
      yield put(setPostApiStatus(true));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPostApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

function* getCustomerUserListHandler(action: CustomerUserActionTypes) {
  yield delay(500);
  try {
    yield startLoader("transparent");

    const { data } = yield call(getCustomerUserListApi, action.payload);

    if (data.status) {
      yield put(setCustomerUserList(data?.data?.rows));
     yield put(setCustomerUserListPageCount(Math.ceil(data?.data?.count / action.payload.pageLimit) || 0));
         }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* getCustomerUserDataByIdHandler(action: CustomerUserActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(getCustomerUserDataByIdApi, action.payload);
    if (data.status) {
      yield put(setCustomerUserDataById(data?.data));
    } else {
      toast.error(data?.message, {
        position: "top-right",
      });
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* editCustomerUserDataByIdHandler(action: CustomerUserActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(editCustomerUserDataByIdApi, action.payload);
    if (data.status) {
      toast.success(data.message, {
        position: "top-right",
      });
      yield put(setPutApiStatus(true));
      yield put(getCustomerUserList({ page: 0, pageLimit: 10 }));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPutApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

function* changeCustomerUserPasswordHandler(action: CustomerUserActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(changeCustomerUserPasswordApi, action.payload);
    if (data.status) {
      toast.success(data.message, {
        position: "top-right",
      });
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
} 

// customer user sagas
export default function* customerUserSaga() {
  yield takeLatest(CustomerUserActions.CREATE_CUSTOMER_USER, createCustomerUserHandler);
  yield takeLatest(CustomerUserActions.GET_CUSTOMER_USER_LIST, getCustomerUserListHandler);
  yield takeLatest(CustomerUserActions.GET_CUSTOMER_USER_DATA_BY_ID, getCustomerUserDataByIdHandler);
  yield takeLatest(CustomerUserActions.EDIT_CUSTOMER_USER_DATA_BY_ID, editCustomerUserDataByIdHandler);
  yield takeLatest(CustomerUserActions.CHANGE_CUSTOMER_USER_PASSWORD, changeCustomerUserPasswordHandler);
}
